// Re-export all public API from split modules
// All consumers import from '@/lib/seo' unchanged

export { escapeJsonLd, buildFaqPageJsonLd, buildMetadata, buildBreadcrumbListJsonLd, buildLanguagesMap } from './utils';
export { buildEventHreflangAlternates, buildHreflangAlternates } from './hreflang';
export {
  getCountrySeoData,
  getCitySeoData,
  getEventSeoData,
  getEventSeoDataTranslated,
  getUniversitySeoData,
  getMonthSeoData,
  getTypeSeoData,
  getReligionHubSeoData,
  getNatureHubSeoData,
  getLongWeekendSeoData,
  getCountryReligionSeoData,
  getCountryNatureSeoData,
} from './seo-data';
export {
  buildCountryJsonLd,
  buildCityJsonLd,
  buildHomepageJsonLd,
  buildOrganizationJsonLd,
  buildEventFaqJsonLd,
  buildEventJsonLd,
  buildEventImageJsonLd,
  buildUniversityJsonLd,
  buildHubJsonLd,
  buildLongWeekendListJsonLd,
  buildUniversityHubJsonLd,
  buildCountryReligionJsonLd,
  buildCountryNatureJsonLd,
  buildPhenomenonJsonLd,
  buildPhenomenonFaqJsonLd,
  buildBestTimeJsonLd,
  buildFestivalIndexJsonLd,
  buildCountryMonthJsonLd,
  buildTouristDestinationJsonLd,
  buildPublisherSnippet,
  buildHowToJsonLd,
  buildArticleJsonLd,
} from './json-ld';
export { getTodaySeoData, buildTodayCollectionJsonLd } from './today-seo';
